import { getStorage, setStorage } from "./storage";
import axios from "axios";

export const createAxiosResponseInterceptor = () => {
  return null;
  const interceptor = axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      // Reject promise if usual error
      if (error.response.status !== 401) {
        return Promise.reject(error);
      }

      /*
       * When response code is 401, try to refresh the token.
       * Eject the interceptor so it doesn't loop in case
       * token refresh causes the 401 response.
       *
       * Must be re-attached later on or the token refresh will only happen once
       */
      axios.interceptors.response.eject(interceptor);

      const user = await getStorage();

      return axios
        .post(process.env.REACT_APP_API + "/account/token/refresh", {
          refreshToken: user.refreshToken,
        })
        .then((response) => {
          saveToken(response);
          error.response.config.headers["Authorization"] =
            "Bearer " + user.accessToken;
          // Retry the initial call, but with the updated token in the headers.
          // Resolves the promise if successful
          return axios(error.response.config);
        })
        .catch((error2) => {
          // Retry failed, clean up and reject the promise
          destroyToken();
          return Promise.reject(error2);
        })
        .finally(createAxiosResponseInterceptor); // Re-attach the interceptor by running the method
    }
  );
};

const saveToken = async (response) => {
  const { accessToken, refreshToken } = response.data;
  const user = await getStorage();

  user.accessToken = accessToken;
  user.refreshToken = refreshToken;

  await setStorage(user);
};

const destroyToken = async () => {
  const user = await getStorage();

  // if (!user?.token) return;
  // sessionStorage.clear();

  // window.location.href = "/login";
};
